export const buildCustomerRatingProperties = ({
  rating,
  reservationId,
}: {
  rating: number;
  reservationId: number;
}) => ({
  cartId: reservationId,
  'Star Rating': rating,
});
